import { Component } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DataService } from '../../services/data.service'; // Importa il servizio
import { FunctionService } from '../../services/function.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [TranslateModule, CommonModule, RouterModule],
  templateUrl: './statistics.component.html',
  styleUrl: './statistics.component.css'
})
export class StatisticsComponent {
  constructor(private dataService: DataService, public functionService: FunctionService) {}
  dashboardData: any; // Proprietà per salvare i dati

  ngOnInit(): void {

  }
}
